 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","account-settings-idea-collection~account-settings-my-profile~admin-home~business-guide-concept-distr~a0369907":"account-settings-idea-collection~account-settings-my-profile~admin-home~business-guide-concept-distr~a0369907","account-settings-idea-collection":"account-settings-idea-collection","settings":"settings","account-settings-my-profile~admin-home~business-guide~business-guide-concept-distribution~business-g~33f1e715":"account-settings-my-profile~admin-home~business-guide~business-guide-concept-distribution~business-g~33f1e715","account-settings-my-profile~admin-home":"account-settings-my-profile~admin-home","account-settings-my-profile":"account-settings-my-profile","admin-home":"admin-home","business-guide-concept-distribution~business-guide-concept-idea~business-guide-concept-partners~busi~841cb349":"business-guide-concept-distribution~business-guide-concept-idea~business-guide-concept-partners~busi~841cb349","business-guide-concept-distribution~business-guide-concept-idea~business-guide-concept-partners~busi~9d617de6":"business-guide-concept-distribution~business-guide-concept-idea~business-guide-concept-partners~busi~9d617de6","business-guide-concept-distribution":"business-guide-concept-distribution","business-guide-concept-partners":"business-guide-concept-partners","business-guide-concept-product":"business-guide-concept-product","business-guide-concept-promotion":"business-guide-concept-promotion","business-guide-projections-direct-costs":"business-guide-projections-direct-costs","business-guide-projections-marketing-budget":"business-guide-projections-marketing-budget","business-guide-projections-other-overheads":"business-guide-projections-other-overheads","business-guide-projections-revenue-streams":"business-guide-projections-revenue-streams","business-guide-research-competitors":"business-guide-research-competitors","business-guide-research-customers":"business-guide-research-customers","business-guide-set-up-financing":"business-guide-set-up-financing","business-guide-set-up-staff-and-payroll":"business-guide-set-up-staff-and-payroll","business-guide-set-up-startup-costs":"business-guide-set-up-startup-costs","financial-plan-expenses-direct-costs":"financial-plan-expenses-direct-costs","financial-plan-expenses-marketing-costs":"financial-plan-expenses-marketing-costs","financial-plan-expenses-other-overheads":"financial-plan-expenses-other-overheads","financial-plan-expenses-payroll-expenses":"financial-plan-expenses-payroll-expenses","financial-plan-expenses-startup-costs":"financial-plan-expenses-startup-costs","financial-plan-financing":"financial-plan-financing","financial-plan-profit-and-cash-flow":"financial-plan-profit-and-cash-flow","financial-plan-revenue":"financial-plan-revenue","business-guide-research-market~financial-plan~payment-login~select-idea-new":"business-guide-research-market~financial-plan~payment-login~select-idea-new","payment-login":"payment-login","select-idea-new":"select-idea-new","home~idea-settings~select-idea":"home~idea-settings~select-idea","home":"home","idea-settings":"idea-settings","select-idea":"select-idea","business-guide~business-guide-concept-idea~business-guide-ownership~business-guide-projections-profi~78627965":"business-guide~business-guide-concept-idea~business-guide-ownership~business-guide-projections-profi~78627965","business-guide-set-up-management-team":"business-guide-set-up-management-team","login~signup~verification":"login~signup~verification","login":"login","verification":"verification","signup":"signup","reset-password":"reset-password","business-guide-ownership~business-plan-shared~financial-plan-expenses-total-costs~financial-plan-ove~36c12551":"business-guide-ownership~business-plan-shared~financial-plan-expenses-total-costs~financial-plan-ove~36c12551","business-plan-shared":"business-plan-shared","business-guide-concept-idea":"business-guide-concept-idea","business-guide-projections-profit-and-cash-flow":"business-guide-projections-profit-and-cash-flow","business-guide-research-market-potential":"business-guide-research-market-potential","business-plan":"business-plan","financial-plan~financial-plan-expenses-total-costs~financial-plan-overview~financial-plan-shared":"financial-plan~financial-plan-expenses-total-costs~financial-plan-overview~financial-plan-shared","financial-plan-overview":"financial-plan-overview","financial-plan-shared":"financial-plan-shared","financial-plan":"financial-plan","business-guide-ownership":"business-guide-ownership","business-guide-research-market":"business-guide-research-market","idea-plan~shared-journal":"idea-plan~shared-journal","idea-plan":"idea-plan","business-guide":"business-guide","validation-idea-score~validation-idea-score-test":"validation-idea-score~validation-idea-score-test","validation-idea-score":"validation-idea-score","validation-idea-score-test":"validation-idea-score-test","ai-assistance":"ai-assistance","app-sumo-signup":"app-sumo-signup","billing":"billing","financial-plan-expenses-total-costs":"financial-plan-expenses-total-costs","shared-journal":"shared-journal","dealify-signup":"dealify-signup","idea-home":"idea-home","invited-users":"invited-users","product-tour":"product-tour"}[chunkId]||chunkId) + "." + {"404":"a02c1491","account-settings-idea-collection~account-settings-my-profile~admin-home~business-guide-concept-distr~a0369907":"de1f6fbf","account-settings-idea-collection":"5841b989","settings":"0a347e68","account-settings-my-profile~admin-home~business-guide~business-guide-concept-distribution~business-g~33f1e715":"549411c7","account-settings-my-profile~admin-home":"3ebac5b9","account-settings-my-profile":"85ffb320","admin-home":"d28816c2","business-guide-concept-distribution~business-guide-concept-idea~business-guide-concept-partners~busi~841cb349":"a16b5a93","business-guide-concept-distribution~business-guide-concept-idea~business-guide-concept-partners~busi~9d617de6":"00e7699d","business-guide-concept-distribution":"0428c74c","business-guide-concept-partners":"8d6e46bb","business-guide-concept-product":"983f2a69","business-guide-concept-promotion":"ceb93965","business-guide-projections-direct-costs":"d7895fea","business-guide-projections-marketing-budget":"db5f56ec","business-guide-projections-other-overheads":"ecf85ac3","business-guide-projections-revenue-streams":"afebdc13","business-guide-research-competitors":"ac393754","business-guide-research-customers":"ba29b4f5","business-guide-set-up-financing":"bdaeff37","business-guide-set-up-staff-and-payroll":"2e3e8dc9","business-guide-set-up-startup-costs":"0f65233e","financial-plan-expenses-direct-costs":"b05299cd","financial-plan-expenses-marketing-costs":"e1856c12","financial-plan-expenses-other-overheads":"1e479258","financial-plan-expenses-payroll-expenses":"e2ac74e2","financial-plan-expenses-startup-costs":"b50c1782","financial-plan-financing":"681cf532","financial-plan-profit-and-cash-flow":"58f8278d","financial-plan-revenue":"3a3dfa17","business-guide-research-market~financial-plan~payment-login~select-idea-new":"84af3266","payment-login":"08586ebd","select-idea-new":"a0393df2","home~idea-settings~select-idea":"3d7c1d25","home":"5ae058bc","idea-settings":"98ed8aef","select-idea":"35418d09","business-guide~business-guide-concept-idea~business-guide-ownership~business-guide-projections-profi~78627965":"3cd152a2","business-guide-set-up-management-team":"9008bb32","login~signup~verification":"d9813f85","login":"9622b93f","verification":"44c8808d","signup":"96ed632c","reset-password":"7b83bdb0","business-guide-ownership~business-plan-shared~financial-plan-expenses-total-costs~financial-plan-ove~36c12551":"35987728","business-plan-shared":"d2351e08","business-guide-concept-idea":"8b2bb147","business-guide-projections-profit-and-cash-flow":"888f84fb","business-guide-research-market-potential":"b1ac961b","business-plan":"75169b04","financial-plan~financial-plan-expenses-total-costs~financial-plan-overview~financial-plan-shared":"2926b8e3","financial-plan-overview":"e884cd43","financial-plan-shared":"6794aa02","financial-plan":"dd1196a8","business-guide-ownership":"660415c2","business-guide-research-market":"810cd764","idea-plan~shared-journal":"109c5b01","idea-plan":"47ad5e70","business-guide":"10d37233","validation-idea-score~validation-idea-score-test":"1e8f247b","validation-idea-score":"d5117efe","validation-idea-score-test":"1a1d3319","ai-assistance":"d1518599","app-sumo-signup":"3c992232","billing":"0bb697ae","financial-plan-expenses-total-costs":"5373bd65","shared-journal":"a064812d","dealify-signup":"7e2fbbb6","idea-home":"a3e50588","invited-users":"bc2ff7a7","product-tour":"3b7c16b5"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/app/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
